import React from 'react';

import HistoryCargoShipmentListPageContainer from './HistoryCargoShipmentListPageContainer';

export class HistoryCargoShipmentListPage extends React.Component{
    
    render(){
      return (
        <HistoryCargoShipmentListPageContainer {...this.props}/>
      )
    }
}